<div class="container" [title]="isAdmin ? 'Build: ' + buildVersion : ''">
  <span class="text-muted">
    Copyright © 2025<span id="2025"></span>
    <a href="javascript:void(0);" class="text-dark fw-medium"> Health4Community</a>
    All rights reserved
  </span>
</div>
